import * as React from 'react';
import './error-screen.styles.es.js';

function RenderErrorScreen(_ref, ref) {
  var _ref$isDevelopment = _ref.isDevelopment,
      isDevelopment = _ref$isDevelopment === void 0 ? "production" === "development" : _ref$isDevelopment;
  {
    throw new Error("Please contact your developer to provide the required parameters to use the Web Payments SDK.");
  }
}

var ErrorScreen = React.forwardRef(RenderErrorScreen);
export { ErrorScreen as default };